import { lazy } from 'react';

export const YourBirthPlacePageLazy = lazy(() => import('./your-birthplace'));
